import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import APIServicenew from "../utils/APIGeneralService";
import { UserContext } from "../context/UserContextProvider";

const ChangePassword = () => {
  const navigate = useNavigate();
  const { accessToken, logout } = useContext(UserContext);

  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);

  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };

  /* ================= Validation ================= */
  const validate = () => {
    const newErrors = {};

    if (!formData.oldPassword) newErrors.oldPassword = "Old password is required.";
    if (!formData.newPassword) {
      newErrors.newPassword = "New password is required.";
    } else if (formData.newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters.";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your new password.";
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================= Submit ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const payload = {
        old_password: formData.oldPassword,
        new_password: formData.newPassword,
      };

      const res = await APIServices.post("profile/change-password", payload, headers);

      if (res?.status === 200) {
        toast.success("Password changed successfully!");
        setFormData({ oldPassword: "", newPassword: "", confirmPassword: "" });
      } else if (res?.status === 401) {
        toast.error("Session expired. Please login again.");
        logout();
        navigate("/login");
      } else {
        toast.error(res?.data?.message || "Failed to change password");
      }
    } catch (err) {
      toast.error("Something went wrong while changing password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="all_content change_password_page">
      <Container fluid>
        <Row className="g-4 justify-content-center">
          <Col lg={6}>
            <div className="white_box h-100 profile-card p-4">
              <h2 className="font_16 font-600 clr_blue mb-4">Change Password</h2>

              <Form onSubmit={handleSubmit} noValidate>
                <Form.Group className="form-floating mb-3">
                  <Form.Control
                    type="password"
                    placeholder="Old Password"
                    value={formData.oldPassword}
                    isInvalid={!!errors.oldPassword}
                    onChange={(e) =>
                      setFormData({ ...formData, oldPassword: e.target.value })
                    }
                  />
                  <Form.Label>Old Password *</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.oldPassword}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="form-floating mb-3">
                  <Form.Control
                    type="password"
                    placeholder="New Password"
                    value={formData.newPassword}
                    isInvalid={!!errors.newPassword}
                    onChange={(e) =>
                      setFormData({ ...formData, newPassword: e.target.value })
                    }
                  />
                  <Form.Label>New Password *</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.newPassword}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="form-floating mb-4">
                  <Form.Control
                    type="password"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    isInvalid={!!errors.confirmPassword}
                    onChange={(e) =>
                      setFormData({ ...formData, confirmPassword: e.target.value })
                    }
                  />
                  <Form.Label>Confirm Password *</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.confirmPassword}
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="d-flex justify-content-between">
                  <Button
                    variant="outline-secondary"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn sky_theme"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Change Password"}
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>

      <ToastContainer />
    </div>
  );
};

export default ChangePassword;
